<template >
  <div class="container-fluid" v-if="lesson">

    <!-- <div class="alert alert-danger my-3 text-center" v-if="enabled!=null && this.enabled!=undefined && this.enabled==false">
      <h3>
        Та төлбөрөө төлөөгүй, дутуу төлсөн эсвэл төлбөр шивэгдээгүй байна.Төлбөр төлөөгүй тохиолдолд шалгалтанд орох боломжгүй.
      </h3>
    </div> -->

    <div class="row">
      <div class="col col-md-8 col-sm-12">
            <h2 class="text-center">{{lesson.name}}</h2>
        <public-topics v-if="topics && topics.length>0" :topics="topics" :lesson="lesson" :types="types" :lessonId="lesson.id"></public-topics>
        <div v-else class="alert alert-warning text-center mb-4"><h4>Одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4></div>
      </div>
      <div class="col col-md-4 col-sm-12">
       <lesson-info :lesson="lesson" :schoolId="null" :edit="false" :showDetail="true"></lesson-info>
      </div>
    </div>


  </div>
    
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex'
import Vue from 'vue'
import VueYoutube from 'vue-youtube'
import PublicTopics from './student/PublicTopics'
import LessonInfo from './shared/LessonInfo';
import lang from './lang.js';

Vue.use(VueYoutube);

export default {
    name: "LessonDetailPublic",
    components:{
      PublicTopics,
      LessonInfo
    },
    mixins:[lang],
    data() {
        return {
            lesson: null,
            topic:{
              'name':null,
              'description':null
            },
            topics:[],
            types:[],
            selectedType:null,
            playerVars: {
              autoplay: 0,
              modestbranding: 1,
              showinfo:0,
              rel:0,
              fs:0
              // controls:0,
              // allowfullscreen:true,
              // autohide:1
            },
            enabled:null
            
        };
    },
    methods: {
     
      async _getQA(){
          fb.db.collection("lessons").doc(this.lessonId).update({"viewCount": fb.firestore.FieldValue.increment(1)});

          fb.db.collection("lessons").doc(this.lessonId).onSnapshot(async doc=> {
              let lesson=doc.data()
              lesson.id=doc.id
              this.lesson=lesson;

              if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
                if(this.lesson && this.lesson.semester){
                  var paymentDoc=await fb.db.collection("students").doc(this.$store.getters.userProfile.customer.id).collection("paymentHistory").doc(this.lesson.semester.id).get();
                  if(paymentDoc.exists && paymentDoc.data() && paymentDoc.data().paid==true){
                    this.enabled=true;
                  }
                  else{
                    this.enabled=false;
                  }

                }

                fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(this.$store.getters.userProfile.customer.id).onSnapshot(stdDoc=> {
                  this.topics=[];
                  if(stdDoc.exists && stdDoc.data().enabled==true){
                    var paymentData=null;
                    
                    fb.db.collection("lessons").doc(this.lessonId).collection("topics").orderBy("createdAt","desc").get().then(querySnapshot=> {
                      
                      querySnapshot.forEach(doc=> {
                        let object=doc.data()
                        object.id = doc.id;
                        object.details=[];

                        object.attendance=false;
                        stdDoc.ref.collection("attendance").doc(doc.id).get().then(atdValue=>{
                          if(atdValue.exists && atdValue.data().status==true)
                            object.attendance=true;
                        });

                        doc.ref.collection("details").orderBy("createdAt").onSnapshot(contentSnapshot=> {
                          object.details=[];
                          contentSnapshot.forEach(contentDoc=> {
                            let content=contentDoc.data()
                            content.id = contentDoc.id;
                            content.uploading=false
                            content.uploadPercent=0
                            object.details.push(content);
                          });
                          
                        });
                        this.topics.push(object);
                      });
                      
                    });
                  }
                });
                
                
              }

          });
          

      },
      
      attendTopic(topic){
        if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
            fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(this.$store.getters.userProfile.customer.id).collection('attendance').doc(topic.id).get().then(value=>{
              if(value.exists){
                if(value.data().status!=true){
                  value.ref.update({status:true});
                }
              }
              else{
                value.ref.set({status:true});
              }
              topic.attendance=true;
            });
        }
      },
      validFile(file){
        if(file.fileName.endsWith("mp4") 
            || file.fileName.endsWith("MP4") 
            || file.fileName.endsWith("MPEG") 
            || file.fileName.endsWith("mov") || file.fileName.endsWith("MOV")
            || file.fileName.endsWith("webm") || file.fileName.endsWith("WEBM")
          ){
            return false;
        }
        return true;
      },
      getYoutubeId(url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = url.match(regExp);

          return (match && match[2].length === 11)
            ? match[2]
            : null;
      },
      getYoutubeIframe(url){
        if(url!=null && url!='' && url.toLowerCase().indexOf("youtube") != -1){
          var id= this.getYoutubeId(url);
          return id ;
        }
        return null;
      },
      goStat(topic, item){
        if(topic!=null && item!=null && item.type!=null && item.type!=undefined && (item.type=='exam' || item.type=='test')){
          this.$router.push({ name: 'TestResult', params: { lessonId: this.lessonId, topicId: topic.id, contentId: item.id} });
        }
      },
      goExamPage(topic, item){
        if(topic!=null && item!=null && item.type!=null && item.type!=undefined && (item.type=='exam' || item.type=='test')){
          this.$router.push({ name: 'ExamPage', params: { lessonId: this.lessonId, topicId: topic.id, contentId: item.id} });
        }
      }


    },
    computed: {
        ...mapState(['userProfile', 'currentUser', "lang"])
    },
    props: {
        lessonId: { 
            required: true,
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
  
};
</script>
<style>
    .video iframe {
        pointer-events: none;
        
    }
 
</style>


